<template>
  <div class="DeleteDocument">
    <div class="image-block">
      <img src="/img/warning.png" alt="">
    </div>
    <div class="text">
      <p>Do you really want to delete this document?</p>
    </div>
    <div class="button-holder">
      <button class="btn cancel" @click="cancel">Cancel</button>
      <button class="btn" @click="deleteDocument">Delete</button>
    </div>
  </div>
</template>

<script>
import DocumentService from '../../../../services/document.service';

export default {
  name: "DeleteDocument",
  props: {
    file: Object
  },
  computed: {
    isDeleteDocument: {
      get() {
        return this.$store.state.isDeleteDocument
      },
      set(value) {
        this.$store.commit('setter', {isDeleteDocument: value})
      }
    },
  },
  methods: {
    cancel() {
      this.isDeleteDocument = false;
    },
    deleteDocument() {
      const query = {
        action: 'deletedocument',
        id: this.file.id,
      }

      DocumentService.execute(query).then(() => {
        this.$store.dispatch('getDocuments', {
          action: 'listdocumentsbylead',
          login: this.Lead.info.login,
        });
        this.isDeleteDocument = false;
        this.isShowDocument = false;
      })
    }
  }
}
</script>

<style lang="scss">
.ShowDocument {
  .DeleteDocument {
    .button-holder {
      justify-content: center;
    }
  }
}

.DeleteDocument {
  padding: 80px 0;

  .image-block {
    text-align: center;
    margin-bottom: 26px;
  }

  .text {
    text-align: center;
    color: #320D57;
    font-size: 23px;
    margin-bottom: 46px;

    p {
      margin: 0;
    }
  }

  .btn {
    &.cancel {
      margin-right: 40px;
    }
  }
}

</style>
